import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular/standalone';
import { CheckboxChangeEventDetail, IonCheckboxCustomEvent, IonRadioGroupCustomEvent, RadioGroupChangeEventDetail } from '@ionic/core';
import { AppCommonModule } from 'src/app/common.module';
import { ImagesComponent } from 'src/app/components/images/images.component';
import { SelectDayComponent } from 'src/app/components/select-day/select-day.component';
import { AddUser } from 'src/app/models/apartment-round.model';
import { PlaygroundCheckReport } from 'src/app/models/playground-check.model';
import { Site } from 'src/app/models/site.model';
import { AddUserDialogComponent } from '../apartment-round/dialog/add-user.dialog';
import { playgroundItems } from './playground';

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    FormsModule,
    SelectDayComponent,
    ImagesComponent,
  ],
})
export class PlaygroundComponent implements OnInit {
  private modalCtrl = inject(ModalController);

  site = input.required<Site>();
  users = input<AddUser[]>([]);
  existing = input<PlaygroundCheckReport>(null);

  report = signal<PlaygroundCheckReport>({
    site: null,
    made: new Date(),
    participants: [],
    swings: {
      seat: { checked: false, images: [] }, suspension: { checked: false, images: [] },
      freeSpace: { checked: false, images: [] }, ropeLength: { checked: false, images: [] }, floor: { checked: false, images: [] },
    },
    slides: {
      surface: { checked: false, images: [] }, sides: { checked: false, images: [] }, areas: { checked: false, images: [] },
      freeSpace: { checked: false, images: [] }, floor: { checked: false, images: [] },
    },
    climb: {
      frame: { checked: false, images: [] }, grap: { checked: false, images: [] }, net: { checked: false, images: [] },
      one: { checked: false, images: [] }, floor: { checked: false, images: [] },
    },
    carousel: { rolling: { checked: false, images: [] }, ground: { checked: false, images: [] }, seats: { checked: false, images: [] }, floor: { checked: false, images: [] } },
    bounce: {
      mat: { checked: false, images: [] }, suspension: { checked: false, images: [] }, height: { checked: false, images: [] }, ground: { checked: false, images: [] },
      blocking: { checked: false, images: [] }, hurdles: { checked: false, images: [] },
    },
  });

  readonly fields = playgroundItems;

  ngOnInit() {
    if (this.existing() != null) {
      this.report.set(this.existing());
    } else {
      this.report().site = this.site().guid;
    }
  }

  getReport() {
    return this.report();
  }

  onDateChange(value: string) {
    const date = new Date(value);
    this.report().made = date;
  }

  onUser(event: IonCheckboxCustomEvent<CheckboxChangeEventDetail<boolean>>, item: AddUser) {
    const checked = event.detail.checked;
    if (checked) {
      this.report().participants.push(item);
    } else {
      this.report().participants = this.report().participants.filter((it) => it.guid !== item.guid);
    }
  }

  addUser() {
    this.modalCtrl.create({ component: AddUserDialogComponent, cssClass: ['stack-modal'] }).then((m) => {
      m.present();

      m.onDidDismiss().then((data) => {
        if (data.data) {
          this.report().participants.push(data.data);
        }
      });
    });
  }

  onRemoveUser(index: number) {
    this.report().participants.splice(index, 1);
  }

  onImage(item: string, subitem: string, url: string) {
    this.report()[item][subitem].images.push(url);
  }

  onDeleteImage(item: string, subitem: string, url: string) {
    this.report()[item][subitem].images = this.report()[item][subitem].images.filter((it) => it !== url);
  }

  onRiskChange(item: string, subitem: string, event: IonRadioGroupCustomEvent<RadioGroupChangeEventDetail<string>>) {
    const value = event.detail.value;
    this.report()[item][subitem].riskLevel = value;
  }
}
